import partial from "rfuncs/functions/partial"
import { process_response } from "workflow/requests/get_url_bytes"

export default async (
  url,
  progress,
  props = {},
  suggested_type = null,
  suggested_name = null
) =>
  fetch(url, {
    method: "HEAD",
    ...props,
  }).then(partial(process_response, suggested_type, suggested_name))
